// extracted by mini-css-extract-plugin
module.exports = {"productTitle":"ProductTitle_productTitle___cM9O","withIcon":"ProductTitle_withIcon__OYY0E"};